// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background: #070707;
    padding-top: 50px;
}

.footer-inner {
    min-height: 363px;
    border-radius: 14px;
    border: 1.23px solid #4E4E4E;
    display: grid;
    grid-template-columns: 1.2fr 1fr 1.5fr;
    font-family: Poppins;
    font-weight: 400;
    font-size: 20.92px;
    line-height: 30.76px;
    letter-spacing: 0px;
    color: #fff;
}

.footer-social-icons {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
}

.footer-social-icons a {
    color: #4E4E4E;
}

.footer-social-icons i {
    color: #4E4E4E;
    font-size: 2.1rem;

}

.footer-social-icons a:hover i {
    color: #faf7f7;
}

.quick-links {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.quick-links a {
    font-family: Poppins;
    font-weight: 400;
    font-size: 18.46px;
    line-height: 24.61px;
    letter-spacing: 0px;
    color: #FFFFFF;
}

.bdr-center {
    border-left: 1.23px solid #FFFFFF;
    border-right: 1.23px solid #FFFFFF;
}

.footercard {
    background: none !important;
    height: 100%;
    padding: 30px;
}

.menu-links {
    display: flex;
    flex-flow: column;
    gap: 12px;
}

.menu-links a {
    color: #fff;
}

.footerlogo {
    height: 100%;

}

.copyright {
    font-family: Poppins;
    font-weight: 400;
    font-size: 20.92px;
    line-height: 30.76px;
    letter-spacing: 0px;
    color: #FFFFFFBD;
    text-align: center;
    padding: 20px;
}

.reis-newsletter {
    display: flex;
    gap: 10px;
    align-items: center;
    position: relative;
    width: auto;
    max-width: 489.74237060546875px;
    height: 55.37287902832031px;

}

.reis-newsletter input.form-control {
    background-color: #232323;
    height: 55px;
    width: 100%;
    color: #fff;
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 24.61px;
    letter-spacing: 0px;
    padding: 10px 40px 10px 20px;
    box-shadow: none !important;
    border: none;
    outline: 0;
}

.reis-newsletter input::placeholder {
    color: #FFFFFF9E;
}

.btn-plane {
    position: absolute;
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0;
    color: #fff;
}
@media (max-width:991px) {
    .footercard
    {
        padding: 10px;
    }
    .footer-social-icons
    {
        gap: 14px;
    }
}
@media (max-width:767px) {
    .footer-inner
    {
        display: grid;
        grid-template-columns: 1fr;
    }
    .footercard {
      
        min-height: 250px;
       
    }
    .bdr-center {
        border-top: 1.23px solid #FFFFFF;
        border-bottom: 1.23px solid #FFFFFF;
        border-left: none;
        border-right: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B,2BAA2B;;AAE/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;AACA;IACI;;QAEI,aAAa;IACjB;IACA;;QAEI,SAAS;IACb;AACJ;AACA;IACI;;QAEI,aAAa;QACb,0BAA0B;IAC9B;IACA;;QAEI,iBAAiB;;IAErB;IACA;QACI,gCAAgC;QAChC,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;IACtB;;AAEJ","sourcesContent":[".footer {\r\n    background: #070707;\r\n    padding-top: 50px;\r\n}\r\n\r\n.footer-inner {\r\n    min-height: 363px;\r\n    border-radius: 14px;\r\n    border: 1.23px solid #4E4E4E;\r\n    display: grid;\r\n    grid-template-columns: 1.2fr 1fr 1.5fr;\r\n    font-family: Poppins;\r\n    font-weight: 400;\r\n    font-size: 20.92px;\r\n    line-height: 30.76px;\r\n    letter-spacing: 0px;\r\n    color: #fff;\r\n}\r\n\r\n.footer-social-icons {\r\n    display: flex;\r\n    gap: 24px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.footer-social-icons a {\r\n    color: #4E4E4E;\r\n}\r\n\r\n.footer-social-icons i {\r\n    color: #4E4E4E;\r\n    font-size: 2.1rem;\r\n\r\n}\r\n\r\n.footer-social-icons a:hover i {\r\n    color: #faf7f7;\r\n}\r\n\r\n.quick-links {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.quick-links a {\r\n    font-family: Poppins;\r\n    font-weight: 400;\r\n    font-size: 18.46px;\r\n    line-height: 24.61px;\r\n    letter-spacing: 0px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.bdr-center {\r\n    border-left: 1.23px solid #FFFFFF;\r\n    border-right: 1.23px solid #FFFFFF;\r\n}\r\n\r\n.footercard {\r\n    background: none !important;\r\n    height: 100%;\r\n    padding: 30px;\r\n}\r\n\r\n.menu-links {\r\n    display: flex;\r\n    flex-flow: column;\r\n    gap: 12px;\r\n}\r\n\r\n.menu-links a {\r\n    color: #fff;\r\n}\r\n\r\n.footerlogo {\r\n    height: 100%;\r\n\r\n}\r\n\r\n.copyright {\r\n    font-family: Poppins;\r\n    font-weight: 400;\r\n    font-size: 20.92px;\r\n    line-height: 30.76px;\r\n    letter-spacing: 0px;\r\n    color: #FFFFFFBD;\r\n    text-align: center;\r\n    padding: 20px;\r\n}\r\n\r\n.reis-newsletter {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    position: relative;\r\n    width: auto;\r\n    max-width: 489.74237060546875px;\r\n    height: 55.37287902832031px;\r\n\r\n}\r\n\r\n.reis-newsletter input.form-control {\r\n    background-color: #232323;\r\n    height: 55px;\r\n    width: 100%;\r\n    color: #fff;\r\n    font-family: Lato;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24.61px;\r\n    letter-spacing: 0px;\r\n    padding: 10px 40px 10px 20px;\r\n    box-shadow: none !important;\r\n    border: none;\r\n    outline: 0;\r\n}\r\n\r\n.reis-newsletter input::placeholder {\r\n    color: #FFFFFF9E;\r\n}\r\n\r\n.btn-plane {\r\n    position: absolute;\r\n    width: 40px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    right: 0;\r\n    color: #fff;\r\n}\r\n@media (max-width:991px) {\r\n    .footercard\r\n    {\r\n        padding: 10px;\r\n    }\r\n    .footer-social-icons\r\n    {\r\n        gap: 14px;\r\n    }\r\n}\r\n@media (max-width:767px) {\r\n    .footer-inner\r\n    {\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .footercard {\r\n      \r\n        min-height: 250px;\r\n       \r\n    }\r\n    .bdr-center {\r\n        border-top: 1.23px solid #FFFFFF;\r\n        border-bottom: 1.23px solid #FFFFFF;\r\n        border-left: none;\r\n        border-right: none;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
